import { render, staticRenderFns } from "./ImportAndSync.vue?vue&type=template&id=4d268f52&"
import script from "./ImportAndSync.vue?vue&type=script&lang=js&"
export * from "./ImportAndSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports